<template :key="buildingId" v-if="$route.params.propertyId">
    <v-list align="center" justify="center">
        <v-list-item class="nav-item active">

            <router-link to="/" style="margin-left: 0px;margin-right:0px">
                <template v-if="mini">
                    <img src="/images/openplanmini.png"
                         alt="avatar"
                         style="
            width: 100%;height:auto;
           " />
                </template>

                <template v-else>
                    <img src="/images/openplan.png"
                         alt="avatar"
                         style="
            width: 100%;
           " />
                </template>

            </router-link>

        </v-list-item>
        <router-link :to="{
          name: 'propertiesowner',
        }">
            <v-list-item :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/units.png" /><span class="nav-title">Units</span>
            </v-list-item>
        </router-link>

        <router-link :to="{
          name: 'userstatementowner',

        }">
            <v-list-item v-if="$route.params.propertyId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/controlpanel.png" /><span class="nav-title">My Statement</span>
            </v-list-item>
        </router-link>

        <router-link :to="{
          name: 'paymentsowner',
        }">
            <v-list-item v-if="$route.params.propertyId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/graphreports.png" /><span class="nav-title">My Receipts</span>
            </v-list-item>
        </router-link>
        <router-link :to="{ name: 'revenuesowner', params:{propertyId:propertyId, propertyName:propertyName}}">
            <v-list-item v-if="$route.params.propertyId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/graphreports.png" /><span class="nav-title">Reports</span>
            </v-list-item>
        </router-link>
        <router-link :to="{ name: 'messagesowner', params:{propertyId:propertyId, propertyName:propertyName}}">
            <v-list-item v-if="$route.params.propertyId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/notifications.png" /><span class="nav-title">Notifications</span>
            </v-list-item>
        </router-link>
    </v-list>
    
</template>
<script>
    import { EventBus } from "@/events";
    import { mapState } from "vuex";
export default {
  data() {
    return {
      color: "#015A6C",
      ismore: false,
    };
  },

  watch: {
    value(val) {
      this.$emit("update:propertyId", val);
    },
    propertyId(val) {
      this.value = val;
      this.$forceUpdate();
    },
  },

        computed: {
            ...mapState(["mini"]),
            mini: {
                get() {
                    return this.$store.state.mini;
                },
                set(val) {
                    this.$store.commit("SET_MINI", val);
                },
            },
    propertyId() {
      return this.$route.params.propertyId;
    },

    propertyName() {
      return this.$route.params.propertyName;
    },
  },
  mounted() {
    this.updatedHandler = function (payLoad) {
      this.propertyId = payLoad;
    };
    EventBus.$on("updated", this.updatedHandler);
  },
  beforeUnmount() {
    EventBus.$off("updated", this.updatedHandler);
  },
  methods: {
    toggledMore() {
      this.ismore = !this.ismore;
    },

    trueMore() {
      this.ismore = true;
    },
  },
};
</script>
